<template>
	<div id="wrapper" class="homepage">
    <div class="wrapper-holder">
       <tpl-header/>
       <section id="main">
                <div class="widget-boxes">
                    <div class="box">
                        <a href="javascript:void(0)">
                            <div class="box-info fun">
                                <h2>Nhận dạy</h2>
                                <p>Organ, piano căn bản, thanh nhạc thiếu nhi.</p>
                            </div>
                        </a>
                    </div>
                    <div class="box">
                        <a href="#">
                            <div class="box-info about">
                                <h2>Giới thiệu</h2>
                                <p>Giáo viên dạy organ, piano, thanh nhạc.</p>
                            </div>
                        </a>
                    </div>
                    <div class="box">
                        <a href="#">
                            <div class="box-info experience">
                                <h2>Kinh nghiệm</h2>
                                <p>Hơn 10 năm giảng dạy organ, piano, thanh nhạc thiếu nhi.</p>
                            </div>
                        </a>
                    </div>
                    
                </div>

                 <div class="top-pink-border"></div>
                <div class="event-wrap">
                    <div class="block-event">
                        <div class="upcoming-event">
                            <h2>Lịch học</h2>
                            <div class="event-description" style="width: max-content">
                                <h3 style="color:#efd37f;font-size:17px;"><strong>Các ngày, giờ học trong tuần</strong></h3>
                                <p></p>
                                <p>Nhận học sinh từ 5 tuổi trở lên</p>
                                <p><strong>Ca 1: 07h30 - 08h30</strong> : Organ + Piano</p>
                                <p><strong>Ca 2: 08h40 - 09h40</strong> : Organ + Piano</p>
                                <p><strong>Ca 3: 09h50 - 10h50</strong> : Organ + Piano</p>
                                <p><strong>Ca 4: 14h00 - 15h00</strong> : Organ + Piano</p>
                                <p><strong>Ca 5: 15h10 - 16h10</strong> : Organ + Piano</p>
                                <p><strong>Ca 6: 16h20 - 17h20</strong> : Thanh nhạc</p>
                                
                                
                                <!--<a class="btn yellow" href="#">Learn more</a> -->
                            </div>
                        </div>
                        <div class="widget-calendar">
                            &nbsp;
                            <!-- <table class="event-calendar">
                                <col>
                                <col>
                                <col>
                                <col>
                                <col>
                                <col>
                                <col>
                                <thead>
                                    <tr>
                                        <th scope="col" class="controls"><span class="prev-mn"><a href="#">-</a></span></th>
                                        <th scope="col" colspan="5" class="month">April 2014</th>
                                        <th scope="col" class="controls"><span class="next-mn"><a href="#">-</a></span></th>
                                    </tr>
                                    <tr>
                                        <th scope="col" title="Monday">Mon</th>
                                        <th scope="col" title="Tuesday">Tue</th>
                                        <th scope="col" title="Wednesday">Wed</th>
                                        <th scope="col" title="Thursday">Thu</th>
                                        <th scope="col" title="Friday">Fri</th>
                                        <th scope="col" title="Saturday">Sat</th>
                                        <th scope="col" title="Sunday">Sun</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><div class="cell-wrap another-day">31</div></td>
                                        <td><div class="cell-wrap">1</div></td>
                                        <td><div class="cell-wrap">2</div></td>
                                        <td><div class="cell-wrap">3</div></td>
                                        <td><div class="cell-wrap">4</div></td>
                                        <td><div class="cell-wrap">5</div></td>
                                        <td>
                                            <div class="cell-wrap archival sun">
                                                <a href="#">6</a>
                                                <div class="tooltip">
                                                    <div class="event-tooltip">
                                                        <h4>Libero tempore cum soluta nobis est eligendi optio</h4>
                                                        <div class="metadata">
                                                            <time datetime="2014-04-06T09:00">
                                                                06.04.14
                                                                <span>09:00 AM</span>
                                                            </time>
                                                            <span class="place">Lorem ipsum dolor</span>
                                                        </div>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In placerat ipsum dui, quis posuere urna fermentum nec. Aliquam erat volutpat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><div class="cell-wrap">7</div></td>
                                        <td><div class="cell-wrap">8</div></td>
                                        <td>
                                            <div class="cell-wrap archival wed">
                                                <a href="#">9</a>
                                                <div class="tooltip">
                                                    <div class="event-tooltip">
                                                        <h4>Libero tempore cum soluta nobis est eligendi optio</h4>
                                                        <div class="metadata">
                                                            <time datetime="2014-04-09T09:00">
                                                                09.04.14
                                                                <span>09:00 AM</span>
                                                            </time>
                                                            <span class="place">Lorem ipsum dolor</span>
                                                        </div>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In placerat ipsum dui, quis posuere urna fermentum nec. Aliquam erat volutpat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td><div class="cell-wrap">10</div></td>
                                        <td><div class="cell-wrap">11</div></td>
                                        <td>
                                            <div class="cell-wrap archival sat">
                                                <a href="#">12</a>
                                                <div class="tooltip">
                                                    <div class="event-tooltip">
                                                        <h4>Libero tempore cum soluta nobis est eligendi optio</h4>
                                                        <div class="metadata">
                                                            <time datetime="2014-04-12T09:00">
                                                                12.04.14
                                                                <span>09:00 AM</span>
                                                            </time>
                                                            <span class="place">Lorem ipsum dolor</span>
                                                        </div>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In placerat ipsum dui, quis posuere urna fermentum nec. Aliquam erat volutpat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td><div class="cell-wrap">13</div></td>
                                    </tr>
                                    <tr>
                                        <td><div class="cell-wrap">14</div></td>
                                        <td><div class="cell-wrap">15</div></td>
                                        <td><div class="cell-wrap">16</div></td>
                                        <td>
                                            <div class="cell-wrap upcoming thu">
                                                <a href="#">17</a>
                                                <div class="tooltip">
                                                    <div class="event-tooltip">
                                                        <h4>Libero tempore cum soluta nobis est eligendi optio</h4>
                                                        <div class="metadata">
                                                            <time datetime="2014-04-17T09:00">
                                                                17.04.14
                                                                <span>09:00 AM</span>
                                                            </time>
                                                            <span class="place">Lorem ipsum dolor</span>
                                                        </div>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In placerat ipsum dui, quis posuere urna fermentum nec. Aliquam erat volutpat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td><div class="cell-wrap">18</div></td>
                                        <td><div class="cell-wrap">19</div></td>
                                        <td><div class="cell-wrap">20</div></td>
                                    </tr>
                                    <tr>
                                        <td><div class="cell-wrap">21</div></td>
                                        <td>
                                            <div class="cell-wrap upcoming tue">
                                                <a href="#">22</a>
                                                <div class="tooltip">
                                                    <div class="event-tooltip">
                                                        <h4>Libero tempore cum soluta nobis est eligendi optio</h4>
                                                        <div class="metadata">
                                                            <time datetime="2014-04-22T09:00">
                                                                22.04.14
                                                                <span>09:00 AM</span>
                                                            </time>
                                                            <span class="place">Lorem ipsum dolor</span>
                                                        </div>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In placerat ipsum dui, quis posuere urna fermentum nec. Aliquam erat volutpat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td><div class="cell-wrap">23</div></td>
                                        <td><div class="cell-wrap">24</div></td>
                                        <td>
                                            <div class="cell-wrap upcoming fri">
                                                <a href="#">25</a>
                                                <div class="tooltip">
                                                    <div class="event-tooltip">
                                                        <h4>Libero tempore cum soluta nobis est eligendi optio</h4>
                                                        <div class="metadata">
                                                            <time datetime="2014-04-25T09:00">
                                                                25.04.14
                                                                <span>09:00 AM</span>
                                                            </time>
                                                            <span class="place">Lorem ipsum dolor</span>
                                                        </div>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In placerat ipsum dui, quis posuere urna fermentum nec. Aliquam erat volutpat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td><div class="cell-wrap">26</div></td>
                                        <td><div class="cell-wrap">27</div></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="cell-wrap upcoming mon">
                                                <a href="#">28</a>
                                                <div class="tooltip">
                                                    <div class="event-tooltip">
                                                        <h4>Libero tempore cum soluta nobis est eligendi optio</h4>
                                                        <div class="metadata">
                                                            <time datetime="2014-04-28T09:00">
                                                                28.04.14
                                                                <span>09:00 AM</span>
                                                            </time>
                                                            <span class="place">Lorem ipsum dolor</span>
                                                        </div>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In placerat ipsum dui, quis posuere urna fermentum nec. Aliquam erat volutpat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td><div class="cell-wrap">29</div></td>
                                        <td><div class="cell-wrap">30</div></td>
                                        <td><div class="cell-wrap another-day">1</div></td>
                                        <td><div class="cell-wrap another-day">2</div></td>
                                        <td><div class="cell-wrap another-day">3</div></td>
                                        <td><div class="cell-wrap another-day">4</div></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="legend"><span class="upcoming">Upcoming event</span><span class="archival">Archival event</span> </div> -->
                        </div>
                    </div>
                </div>
                <div class="bottom-pink-border"></div>
                <div class="news"></div>
            </section>
    </div>
    <div class="top-blue-border"></div>
    <site-footer/>
	</div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

  export default {
    components: {
      'tpl-header': Header,
      'site-footer': Footer
    },
    name: 'app',
  }
</script>

<style>
  /* @import '~/static/css/style.css'; */
</style>